<template>
  <!--begin::Dashboard-->
  <div class="p-5 container" :key="componentKey">
    <div class="row mb-5" style="padding: 2vh;">
      <div
        class="col-12 col-lg-6"
        style="font-style: normal;
                  font-weight: 500;
                  font-size: 30px;
                  line-height: 39px;
                  color: #000000;"
      >
      {{ myExam["title"] }}
        <!-- {{ answersList }} -->
      </div>
      <div
        class="col-12 col-lg-6"
        style="display: flex;flex-direction: row;flex-wrap: wrap;align-items: center;justify-content: space-around;"
      >
        <span
          style="font-style: normal;
                  font-weight: 500;
                  font-size: 20px;
                  line-height: 26px;
                  color: #000000;"
        >
          คำถามข้อที่
          <span style="color:#F2A17D">{{ page + 1 }}</span> /
          {{ listData ? listData.length : "0" }}</span
        >

        <button
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#kt_modal_answers"
          class="btn btn-info"
        >
          กระดาษคำตอบ
        </button>
        <span
          style="font-weight: 400;
                    font-size: 20px;
                    line-height: 26px;
                    color: #000000;"
        >
          <i class="fa fa-clock"></i> {{ countdown }}</span
        >
      </div>
      <div
        class="col-12 mt-5"
        :key="contentKey"
        v-if="listData"
        style="background: #F7F7F7;
                  border: 1px solid #D8D8D8;
                  border-radius: 15px;
                  padding: 20px;"
      >
        <div class="row" style="position: relative;">
          <video
            v-if="isCameraOpen == true"
            ref="video"
            id="video"
            style="width: 200px;height:auto;position: absolute;"
            autoplay
          ></video>
          <div class="col-12 col-lg-8 offset-lg-2">
            <canvas
              style="display: none;"
              ref="canvas"
              id="canvas"
              width="640"
              height="480"
            ></canvas>
            <!-- <div v-for="(item, index) in captures" :key="index">
              <img v-bind:src="item" style="width: 100%" />
            </div> -->
            <p
              style="font-style: normal;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 23px;"
            >
              {{ listData[page].textQuestion }}
            </p>
            <img
              v-if="listData[page].imageQuestion"
              :src="imageUrl + listData[page].imageQuestion"
              alt=""
            />

            <div class="row" v-if="listData[page].qType == 1">
              <div
                class="col-12 col-md-6 p-5"
                v-for="(itemA, indexA) in listData[page].questionChoices"
                :key="indexA"
              >
                <div
                  @click="setAnswer(listData[page].id, itemA.choiceId, 1, page)"
                  style="background: #FFFFFF;
                          border-radius: 10px;
                          height: 100%;
                          padding: 20px;"
                >
                  <img
                    v-if="itemA.imageChoice"
                    :src="imageUrl + itemA.imageChoice"
                    class="w-100"
                    alt=""
                  />
                  <div
                    class="form-check form-check-custom form-check-success form-check-solid my-3"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      :name="'qId' + listData[page].id"
                      :value="itemA.choiceId"
                      :id="'qaId' + itemA.choiceId"
                      @click="
                        setAnswer(listData[page].id, itemA.choiceId, 1, page)
                      "
                      :checked="answer[page] == itemA.choiceId ? true : false"
                    />
                    <!-- v-model="answer[page]" -->

                    <label
                      class="form-check-label"
                      :for="'qaId' + itemA.choiceId"
                    >
                      {{ itemA.textChoice }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="my-5">
              <input
                type="text"
                v-model="answer[page]"
                class="form-control"
                @change="setAnswer(listData[page].id, answer[page], 2, page)"
              />
            </div>
            <div style="display: flex;justify-content: space-between;">
              <button
                type="button"
                @click="previousPage()"
                :disabled="page == 0"
                class="btn btn-exam"
              >
                ก่อนหน้า
              </button>
              <button
                v-if="page == listData.length - 1"
                :disabled="submitButton"
                type="button"
                @click="submit()"
                class="btn btn-exam"
              >
                ส่งคำตอบ
              </button>
              <button
                v-else
                type="button"
                @click="nextPage()"
                class="btn btn-exam"
              >
                ถัดไป
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="kt_modal_answers"
    tabindex="-1"
    aria-hidden="true"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-650px">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header" id="kt_modal_answers_header">
          <!--begin::Modal title-->
          <h2>กระดาษคำตอบ</h2>
          <!-- {{answer}} -->
          <!--end::Modal title-->
          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body py-10 px-lg-17" v-if="listData">
          <div
            v-for="(item, index) in listData"
            :key="index"
            :id="item.qaId"
            class="subject "
          >
            <span
              ><button
                class="btn btn-sm w-80px my-2 btn-primary"
                @click="changePage(index)"
              >
                ข้อ {{ index + 1 }}.</button
              >&nbsp;&nbsp;&nbsp;
              <span v-if="listData[index].qType == 1">
                <span
                  v-for="(item, indexA) in item.questionChoices"
                  :key="indexA"
                  :class="
                    item.choiceId == answer[index]
                      ? 'choice green'
                      : 'choice grey'
                  "
                  >{{ indexA + 1 }}</span
                >
              </span>
              <span v-else class="mx-5">
                {{ answer[index] ? answer[index].toString() : "" }}
              </span>
            </span>
          </div>
        </div>
        <div class="modal-footer flex-center"></div>
      </div>
    </div>
  </div>
  <!-- dialog score -->
  <!-- <el-button text @click="dialogVisible = true">
    click to open the Dialog
  </el-button> -->

  <el-dialog
    v-model="dialogVisible"
    title=""
    width="30%"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <div style="text-align: center;">
      <strong v-if="currentPercent >= percentPass"
        >ยินดีด้วย คุณผ่านการทดสอบ!</strong
      >
      <strong v-else>เสียใจด้วย คุณไม่ผ่านการทดสอบ</strong>
      <p v-if="currentPercent >= percentPass">
        กรุณารอการตรวจสอบข้อมูลจากเจ้าหน้าที่
        และจะได้รับใบรับรองทันทีหลังข้อมูลได้รับการอนุมัติ
      </p>
      <p v-else>
        โปรดติดต่อเจ้าหน้าที่
        เพื่อขอทำการทดสอบอีกครั้งโดยจะต้องทำการจองเพื่อขอสอบผ่านระบบเท่านั้น
      </p>
      <!-- คะแนนของคุณคือ<br />
      <span class="score_big">{{ currentScoreUser }}</span> /
      {{ currentScore }} คะแนน<br /> -->
      <div class="card">
        <div class="card-body">
          <p style="text-align: left;">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M17.6423 2.21644C17.045 2.11355 16.4401 2.06059 15.834 2.05811C13.7659 2.05641 11.741 2.64942 10.0006 3.76644C8.25576 2.66409 6.23118 2.08563 4.16731 2.09978C3.56118 2.10226 2.95631 2.15522 2.35897 2.25811C2.16331 2.29184 1.98612 2.39432 1.85932 2.5471C1.73251 2.69988 1.66442 2.89292 1.66731 3.09144V13.0914C1.66552 13.2139 1.69075 13.3352 1.74118 13.4468C1.79162 13.5584 1.86603 13.6575 1.95912 13.7371C2.05221 13.8166 2.16169 13.8747 2.27977 13.9071C2.39785 13.9396 2.52163 13.9456 2.64231 13.9248C3.83649 13.718 5.05998 13.7523 6.2407 14.0257C7.42142 14.299 8.53549 14.8059 9.51731 15.5164L9.61731 15.5748H9.70897C9.80139 15.6133 9.90052 15.6331 10.0006 15.6331C10.1008 15.6331 10.1999 15.6133 10.2923 15.5748H10.384L10.484 15.5164C11.4589 14.79 12.5698 14.2667 13.7508 13.9776C14.9317 13.6884 16.1587 13.6393 17.359 13.8331C17.4796 13.8539 17.6034 13.8479 17.7215 13.8155C17.8396 13.783 17.9491 13.725 18.0422 13.6454C18.1353 13.5658 18.2097 13.4667 18.2601 13.3551C18.3105 13.2436 18.3358 13.1222 18.334 12.9998V2.99978C18.3253 2.8099 18.252 2.6287 18.1262 2.48622C18.0004 2.34375 17.8296 2.24856 17.6423 2.21644ZM9.16731 13.2914C7.62554 12.4803 5.90941 12.057 4.16731 12.0581C3.89231 12.0581 3.61731 12.0581 3.33397 12.0581V3.72478C3.61152 3.70878 3.88976 3.70878 4.16731 3.72478C5.94513 3.72281 7.68415 4.24452 9.16731 5.22478V13.2914ZM16.6673 12.0914C16.384 12.0914 16.109 12.0914 15.834 12.0914C14.0919 12.0904 12.3757 12.5137 10.834 13.3248V5.22478C12.3171 4.24452 14.0562 3.72281 15.834 3.72478C16.1115 3.70878 16.3898 3.70878 16.6673 3.72478V12.0914ZM17.6423 15.5498C17.045 15.4469 16.4401 15.3939 15.834 15.3914C13.7659 15.3897 11.741 15.9828 10.0006 17.0998C8.26024 15.9828 6.23534 15.3897 4.16731 15.3914C3.56118 15.3939 2.95631 15.4469 2.35897 15.5498C2.2505 15.567 2.14649 15.6055 2.05294 15.663C1.95939 15.7206 1.87814 15.7961 1.81386 15.8851C1.74958 15.9742 1.70354 16.0751 1.67839 16.182C1.65324 16.2889 1.64947 16.3997 1.66731 16.5081C1.70966 16.7245 1.83605 16.9153 2.0188 17.0387C2.20155 17.1621 2.42576 17.208 2.64231 17.1664C3.83649 16.9597 5.05998 16.994 6.2407 17.2673C7.42142 17.5407 8.53549 18.0476 9.51731 18.7581C9.65844 18.8586 9.82739 18.9126 10.0006 18.9126C10.1739 18.9126 10.3428 18.8586 10.484 18.7581C11.4658 18.0476 12.5799 17.5407 13.7606 17.2673C14.9413 16.994 16.1648 16.9597 17.359 17.1664C17.5755 17.208 17.7997 17.1621 17.9825 17.0387C18.1652 16.9153 18.2916 16.7245 18.334 16.5081C18.3518 16.3997 18.348 16.2889 18.3229 16.182C18.2977 16.0751 18.2517 15.9742 18.1874 15.8851C18.1231 15.7961 18.0419 15.7206 17.9483 15.663C17.8548 15.6055 17.7508 15.567 17.6423 15.5498Z"
                fill="#6B6B6B"
              /></svg>
              จำนวนข้อสอบ : {{ currentScore }} ข้อ
          </p>
          <p style="text-align: left;">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M16.6654 7.94984C16.6567 7.87328 16.6399 7.79786 16.6154 7.72484V7.64984C16.5753 7.56415 16.5219 7.48539 16.457 7.4165L11.457 2.4165C11.3881 2.35168 11.3094 2.29824 11.2237 2.25817C11.1988 2.25464 11.1736 2.25464 11.1487 2.25817C11.064 2.20962 10.9706 2.17846 10.8737 2.1665H5.83203C5.16899 2.1665 4.53311 2.4299 4.06426 2.89874C3.59542 3.36758 3.33203 4.00346 3.33203 4.6665V16.3332C3.33203 16.9962 3.59542 17.6321 4.06426 18.1009C4.53311 18.5698 5.16899 18.8332 5.83203 18.8332H14.1654C14.8284 18.8332 15.4643 18.5698 15.9331 18.1009C16.402 17.6321 16.6654 16.9962 16.6654 16.3332V7.99984C16.6654 7.99984 16.6654 7.99984 16.6654 7.94984ZM11.6654 5.00817L13.8237 7.1665H12.4987C12.2777 7.1665 12.0657 7.07871 11.9094 6.92243C11.7532 6.76615 11.6654 6.55418 11.6654 6.33317V5.00817ZM14.9987 16.3332C14.9987 16.5542 14.9109 16.7661 14.7546 16.9224C14.5983 17.0787 14.3864 17.1665 14.1654 17.1665H5.83203C5.61102 17.1665 5.39906 17.0787 5.24278 16.9224C5.0865 16.7661 4.9987 16.5542 4.9987 16.3332V4.6665C4.9987 4.44549 5.0865 4.23353 5.24278 4.07725C5.39906 3.92097 5.61102 3.83317 5.83203 3.83317H9.9987V6.33317C9.9987 6.99621 10.2621 7.6321 10.7309 8.10094C11.1998 8.56978 11.8357 8.83317 12.4987 8.83317H14.9987V16.3332ZM11.907 10.7415L9.16536 13.4915L8.09036 12.4082C7.93344 12.2513 7.72062 12.1631 7.4987 12.1631C7.27678 12.1631 7.06395 12.2513 6.90703 12.4082C6.75011 12.5651 6.66195 12.7779 6.66195 12.9998C6.66195 13.2218 6.75011 13.4346 6.90703 13.5915L8.5737 15.2582C8.65117 15.3363 8.74333 15.3983 8.84488 15.4406C8.94643 15.4829 9.05535 15.5047 9.16536 15.5047C9.27537 15.5047 9.3843 15.4829 9.48585 15.4406C9.58739 15.3983 9.67956 15.3363 9.75703 15.2582L13.0904 11.9248C13.2473 11.7679 13.3354 11.5551 13.3354 11.3332C13.3354 11.1113 13.2473 10.8984 13.0904 10.7415C12.9334 10.5846 12.7206 10.4964 12.4987 10.4964C12.2768 10.4964 12.064 10.5846 11.907 10.7415Z"
                fill="#6B6B6B"
              /></svg>
              คะแนนเต็ม : {{ currentScore }} คะแนน
          </p>
          <p style="text-align: left;">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M12.268 7.82484L8.69297 11.4082L7.31797 10.0332C7.24327 9.94594 7.15133 9.87509 7.04795 9.82507C6.94456 9.77505 6.83195 9.74694 6.71718 9.74251C6.60242 9.73807 6.48797 9.75741 6.38104 9.79931C6.2741 9.8412 6.17698 9.90475 6.09576 9.98596C6.01455 10.0672 5.951 10.1643 5.90911 10.2712C5.86721 10.3782 5.84787 10.4926 5.85231 10.6074C5.85674 10.7221 5.88485 10.8348 5.93487 10.9381C5.98489 11.0415 6.05574 11.1335 6.14297 11.2082L8.10131 13.1748C8.17917 13.2521 8.27152 13.3132 8.37305 13.3546C8.47458 13.3961 8.5833 13.4171 8.69297 13.4165C8.91159 13.4156 9.12109 13.3288 9.27631 13.1748L13.443 9.00817C13.5211 8.9307 13.5831 8.83853 13.6254 8.73698C13.6677 8.63544 13.6895 8.52651 13.6895 8.4165C13.6895 8.30649 13.6677 8.19757 13.6254 8.09602C13.5831 7.99447 13.5211 7.90231 13.443 7.82484C13.2868 7.66963 13.0756 7.58251 12.8555 7.58251C12.6353 7.58251 12.4241 7.66963 12.268 7.82484ZM10.0013 2.1665C8.35313 2.1665 6.74196 2.65525 5.37155 3.57092C4.00114 4.4866 2.93304 5.78809 2.30231 7.31081C1.67158 8.83353 1.50655 10.5091 1.8281 12.1256C2.14964 13.7421 2.94331 15.227 4.10875 16.3924C5.27419 17.5578 6.75905 18.3515 8.37555 18.673C9.99206 18.9946 11.6676 18.8296 13.1903 18.1988C14.7131 17.5681 16.0145 16.5 16.9302 15.1296C17.8459 13.7592 18.3346 12.148 18.3346 10.4998C18.3346 9.40549 18.1191 8.32186 17.7003 7.31081C17.2815 6.29976 16.6677 5.3811 15.8939 4.60728C15.12 3.83346 14.2014 3.21963 13.1903 2.80084C12.1793 2.38205 11.0957 2.1665 10.0013 2.1665ZM10.0013 17.1665C8.68276 17.1665 7.39383 16.7755 6.2975 16.043C5.20118 15.3104 4.34669 14.2692 3.84211 13.0511C3.33752 11.8329 3.2055 10.4924 3.46274 9.19924C3.71997 7.90603 4.35491 6.71814 5.28726 5.78579C6.21961 4.85344 7.4075 4.2185 8.7007 3.96127C9.99391 3.70403 11.3344 3.83606 12.5525 4.34064C13.7707 4.84522 14.8119 5.69971 15.5444 6.79604C16.277 7.89236 16.668 9.1813 16.668 10.4998C16.668 12.2679 15.9656 13.9636 14.7154 15.2139C13.4651 16.4641 11.7694 17.1665 10.0013 17.1665Z"
                fill="#6B6B6B"
              /></svg >
              เกณฑ์การผ่าน : {{percentPass}}
          </p>
          <div class="d-flex">
            <div class="w-50" style="text-align: left;">
              <b>คะแนนของคุณคือ</b>
              <p>{{currentScoreUser}} / {{currentScore}} คะแนน</p>
              <p>เวลาในการทำข้อสอบ :  {{ currentTimeSubmit }} นาที</p>
            </div>
            <div style="position: relative;">
              <el-progress
                type="circle"
                :percentage="currentPercent"
                :color="customColorMethod"
              />
            </div>
          </div>
        </div>
      </div>
      <el-button class="mt-5" type="primary" @click="onBack()">
        ตกลง
      </el-button>
    </div>
  </el-dialog>
</template>
<script lang="ts">
/* eslint-disable */
import { defineComponent, nextTick, onMounted, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import jQuery from "jquery";
import { useCookies } from "vue3-cookies";
const $ = jQuery;
const customColorMethod = (percentage: number) => {
  if (percentage < 60) {
    return "#f56c6c";
  }
  return "#67c23a";
};
const dialogVisible = ref(false);
const video = ref();
const canvas = ref();
const captures = ref([] as Array<object>);
const isCameraOpen = ref(false);
const listData = ref();
const page = ref(0);
const score = ref(0);
const contentKey = ref(0);
const answer = ref([] as Array<object>);
const answersList = ref([
  {
    questionId: "",
    choiceId: [],
    answerUser: "",
  },
]);
import router from "@/router";
const { cookies } = useCookies();
const submitButton =ref(false)
export default defineComponent({
  name: "exam-test",
  components: {},
  data() {
    return {
      checkPermission: 0,
      timeInSecs: 0,
      ticker: 0,
      imageUrl: process.env.VUE_APP_IMG_URL,
      countdown: "",
      dataParams: this.$route.params,
      localStream: {
        srcObject: "",
      },
      examRoomProfile: "",
      componentKey: 0,
      percentPass: 0,
      currentScore: 0,
      currentScoreUser: 0,
      currentPercent: 0,
      currentTimeSubmit: "",
      currentSyllabusId:"",
      myExam:[]
    };
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    onMounted(async () => {
      answersList.value = [];
      if (!cookies.get("examRoomId")) {
        cookies.set("examRoomId", route.params.exrId + "");
      }
      await getDataList();
      if (
        localStorage.getItem("u_id") == cookies.get("userAnswerId") &&
        route.params.exrId == cookies.get("examRoomId") &&
        cookies.get("answersList")
      ) {
        answersList.value = JSON.parse(cookies.get("answersList"));
        for (let index = 0; index < answersList.value.length; index++) {
          // console.log("set answersList from cookies" + index);
          // console.log(answersList.value[index].answerUser);
          if (answersList.value[index].answerUser) {
            answer.value[index] = [answersList.value[index].answerUser];
          } else {
            answer.value[index] = answersList.value[index].choiceId[0];
          }
        }
      }
    });
    const getDataList = () => {
      if (!localStorage.getItem("ExamQuestion")) {
        axios
          .get(
            process.env.VUE_APP_API_URL +
              "/getExamQuestion?examId=" +
              route.params.exId,
            {
              headers: {
                 token: localStorage.getItem("id_token")
              },
            }
          )
          .then((response) => {
            listData.value = response.data.data;
            // console.log("getExamQuestion");
            if (listData.value.length>0) {
              localStorage.setItem(
              "ExamQuestion",
              JSON.stringify(listData.value)
            );
            }
           
            // cookies.set("ExamQuestion", JSON.stringify(listData.value));
            // setCurrentPageBreadcrumbs(listData.value.title, []);
          })
          .catch((error) => {
            // console.log(error);
          });
        // if (isCameraOpen.value == false) {
        //   console.log(video.value);
        // }
      } else {
        // console.log("cookies");
        listData.value = JSON.parse(localStorage.getItem("ExamQuestion")!);
      }
    };
    const previousPage = () => {
      page.value = page.value - 1;
      contentKey.value += 1;
    };
    const nextPage = () => {
      page.value = page.value + 1;
      contentKey.value += 1;
    };
    const changePage = (event) => {
      page.value = event;
      contentKey.value += 1;
    };
    const setDataInArrayObjectById = (array, id, answer, type) => {
      const foundObject = array.find((obj) => obj.questionId === id);
      if (!foundObject) {
        return false;
      }
    };
    const setAnswer = (qId, dataAnswer, type, page) => {
      // console.log("setAnswer");
      const list: any = {};
      if (answersList.value.length > 0) {
        console.log(answersList.value);
        if (
          setDataInArrayObjectById(answersList.value, qId, dataAnswer, type) ==
          false
        ) {
          if (type == 1) {
            answer.value[page] = dataAnswer;
            list.questionId = qId;
            list.choiceId = [dataAnswer];
            list.answerUser = "";
          } else {
            list.questionId = qId;
            list.choiceId = [];
            list.answerUser = dataAnswer;
          }
        } else {
          for (const loopAnswer of answersList.value) {
            const data: any = [];
            data.push(dataAnswer);
            // console.log(dataAnswer);
            if (loopAnswer.questionId == qId) {
              if (type == 1) {
                answer.value[page] = dataAnswer;
                loopAnswer.choiceId = data;
                loopAnswer.answerUser = "";
              } else {
                loopAnswer.choiceId = [];
                loopAnswer.answerUser = dataAnswer;
              }
            }
          }
        }
      } else {
        if (type == 1) {
          answer.value[page] = dataAnswer;
          list.questionId = qId;
          list.choiceId = [dataAnswer];
          list.answerUser = "";
        } else {
          list.questionId = qId;
          list.choiceId = [];
          list.answerUser = dataAnswer;
        }
      }
      if (list.questionId) {
        answersList.value.push(list);
      }
      // console.log(answer.value);
      // console.log(answersList.value);
      // console.log(answersList.value);
      cookies.set("answersList", JSON.stringify(answersList.value));
      cookies.set("userAnswerId", localStorage.getItem("u_id")!);
      // localStorage.setItem("qId" + qId, qaId);
    };

    return {
      getDataList,
      listData,
      page,
      previousPage,
      nextPage,
      answer,
      changePage,
      setAnswer,
      video,
      canvas,
      captures,
      isCameraOpen,
      route,
      answersList,
      setDataInArrayObjectById,
      contentKey,
      customColorMethod,
      dialogVisible,
      submitButton
    };
  },
  created() {
    this.forceRerender();
  },
  async mounted() {
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
      this.componentKey += 1;
      page.value = 0;
    }
    const exam = await axios.get(
      process.env.VUE_APP_API_URL + "/getExam?id=" + this.$route.params.exId,
      {
        headers: {
           token: localStorage.getItem("id_token")
        },
      }
    );

    this.myExam = exam.data.data.content[0];
    this.percentPass = exam.data.data.content[0].percentPass;
    // console.log("getExam");
    // console.log(this.myExam);
    setCurrentPageBreadcrumbs(this.myExam["title"], []);

    // if (isCameraOpen.value == false) {
    //   console.log(video.value);
    // }
    const exData = await axios.get(
      process.env.VUE_APP_API_URL +
        "/getExamRoomRegister?examRoomId=" +
        this.$route.params.exrId +
        "&isDetail=true",
      {
        headers: {
           token: localStorage.getItem("id_token")
        },
      }
    );
    // console.log(exData.data.data.content[0].examRoomProfile);
    this.examRoomProfile = exData.data.data.content[0].examRoomProfile;
    // this.createCameraElement();
    Swal.fire({
      title: "แบบทดสอบ",
      text:
        "ระบบจะจับเวลาและบันทึกการทำข้อสอบทันที เมื่อคุณกดปุ่มเริ่มทำข้อสอบ",
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#323563",
      cancelButtonColor: "#d33",
      allowOutsideClick: false,
      confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
      cancelButtonText: "กลับสู่หน้าหลัก",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append(
          "examRoomCode",
          this.examRoomProfile["examRoomCode"] + ""
        );
        formData.append(
          "examRoomPwd",
          this.examRoomProfile["examRoomPwd"] + ""
        );
        // console.log("update");
        const startTestExamRoomRegister = await axios.post(
          process.env.VUE_APP_API_URL + "/startTestExamRoomRegister",
          formData,
          { headers: {
             token: localStorage.getItem("id_token")
          } }
        );
        // console.log(startTestExamRoomRegister);
        if (
          localStorage.getItem("u_id") == cookies.get("userAnswerId") &&
          cookies.get("time") &&
          cookies.get("examRoomId")
        ) {
          if (
            cookies.get("time") != "NaN" &&
            cookies.get("examRoomId") != "NaN" &&
            cookies.get("examRoomId") == this.$route.params.exrId
          ) {
            this.startTimer(parseInt(cookies.get("time")));
          } else {
            this.startTimer(this.examRoomProfile["examProfile"].limitTime * 60);
          }
        } else {
          this.startTimer(this.examRoomProfile["examProfile"].limitTime * 60);
        }
      } else {
        router.push({
          name: "exam-detail",
          params: { id: this.$route.params.exrId },
        });
      }
    });
  },
  methods: {
    // todo() {
    //   isCameraOpen.value = true;
    //   this.createCameraElement();
    //   window.setInterval(() => {
    //     this.capture();
    //   }, 2000); // interval set to one sec.
    // },
    // checkCamera() {
    //   this.checkPermission = window.setInterval(() => {
    //     if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    //       navigator.mediaDevices
    //         .getUserMedia({ video: true, audio: false })
    //         .then((stream) => {
    //           // console.log(stream);
    //         })
    //         .catch((error) => {
    //           clearInterval(this.checkPermission);
    //           console.log(error);
    //           Swal.fire({
    //             title: "กรุณาให้สิทธิ webcam ในการทำข้อสอบ",
    //             icon: "warning",
    //             showCancelButton: true,
    //             confirmButtonColor: "#323563",
    //             cancelButtonColor: "#d33",
    //             confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
    //             allowOutsideClick: false,
    //             cancelButtonText: "กลับสู่หน้าหลัก",
    //           }).then((result) => {
    //             if (result.isConfirmed) {
    //               this.createCameraElement();
    //             } else {
    //               router.push({
    //                 name: "voluntary-detail",
    //                 params: { id: this.$route.params.exrId },
    //               });
    //             }
    //           });
    //         });
    //     }
    //   }, 2000);
    // },
    formatDate(date) {
      const event = new Date(date);
      return event.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    formatDateTime(date) {
      const event = new Date(date);
      return (
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }) + " น."
      );
    },
    // toggleCamera() {
    //   if (isCameraOpen.value) {
    //     isCameraOpen.value = false;
    //     this.stopCameraStream();
    //   } else {
    //     isCameraOpen.value = true;
    //     this.createCameraElement();
    //   }
    //   //  createCameraElement();
    //   //  stopCameraStream();
    // },
    // createCameraElement() {
    //   isCameraOpen.value = true;
    //   if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    //     navigator.mediaDevices
    //       .getUserMedia({ video: true, audio: false })
    //       .then((stream) => {
    //         video.value.srcObject = stream;
    //         video.value.play();
    //         this.startTimer(5 * 60);
    //         this.checkCamera();
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //         Swal.fire({
    //           title: "กรุณาให้สิทธิ webcam ในการทำข้อสอบ",
    //           icon: "warning",
    //           showCancelButton: true,
    //           confirmButtonColor: "#323563",
    //           cancelButtonColor: "#d33",
    //           confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
    //           allowOutsideClick: false,
    //           cancelButtonText: "กลับสู่หน้าหลัก",
    //         }).then((result) => {
    //           if (result.isConfirmed) {
    //             this.createCameraElement();
    //           } else {
    //             router.push({
    //               name: "voluntary-detail",
    //               params: { id: this.$route.params.exrId },
    //             });
    //           }
    //         });
    //       });
    //   }
    // },
    // stopCameraStream() {
    //   video.value = video.value.srcObject.getTracks();
    //   video.value.forEach((track) => {
    //     track.stop();
    //   });
    // },
    // capture() {
    //   /* eslint-disable */
    //   canvas.value = this.$refs.canvas;
    //   var context: any = canvas.value
    //     .getContext("2d")
    //     .drawImage(this.video, 0, 0, 640, 480);
    //   console.log(canvas.value.toDataURL("image/png"));
    //   captures.value.push(canvas.value.toDataURL("image/png"));
    //   // this.captures.push(canvas.value.toDataURL("image/png"));
    //   /* eslint-disable */
    // },
    startTimer(secs) {
      this.timeInSecs = parseInt(secs);
      this.ticker = window.setInterval(() => {
        this.tick();
      }, 1000);
    },
    tick() {
      let secs = this.timeInSecs;
      cookies.set("time", secs + "");
      if (secs > 0) {
        this.timeInSecs--;
      } else {
        clearInterval(this.ticker);
        Swal.fire({
          title: "หมดเวลาทำข้อสอบแล้ว!",
          text: "ต้องการส่งคำตอบหรือไม่ ?",
          icon: "error",
          buttonsStyling: false,
          showCancelButton: true,
          allowOutsideClick: false,
          confirmButtonText: "ส่งข้อสอบ",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-primary",
            cancelButton: "btn fw-semobold btn-light-danger",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.submit();
          } else {
            this.$router.go(-1);
          }
        });
      }
      const mins = Math.floor(secs / 60);
      secs %= 60;
      const pretty =
        (mins < 10 ? "0" : "") + mins + ":" + (secs < 10 ? "0" : "") + secs;
      this.countdown = pretty;
      localStorage.setItem("timer", secs + "");
    },
    percentageToDegrees(percentage) {
      return (percentage / 100) * 360;
    },
    async submit() {
      submitButton.value = true
      Swal.fire({
        title: "ต้องการส่งคำตอบใช่หรือไม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#323563",
        cancelButtonColor: "#d33",
        confirmButtonText: "ใช่",
        allowOutsideClick: false,
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Loading",
            allowOutsideClick: false,
            onBeforeOpen: () => {
              Swal.showLoading();
            },
          });
          localStorage.removeItem("ExamQuestion");
          cookies.remove("examRoomId");
          cookies.remove("time");
          cookies.remove("userAnswerId");
          cookies.remove("answersList");
          clearInterval(this.ticker);
          clearInterval(this.checkPermission);
          const examId = this.$route.params.exId;
          const syllabusRegisterId = this.$route.params.sbId;
          const examRoomId = this.$route.params.exrId;
          const timeSubmit = this.convertStoMs(
            parseFloat(this.myExam["limitTime"]),
            parseFloat(this.countdown.replace(":", "."))
          );
          score.value = 0;
          axios
            .post(
              process.env.VUE_APP_API_URL + "/checkAnswer",
              answersList.value,
              {
                headers: {
                   token: localStorage.getItem("id_token")
                },
              }
            )
            .then((res) => {
              score.value = res.data.data.score;
              const formData = new FormData();
              formData.append("score", score.value + "");
              formData.append("examId", examId + "");
              formData.append("syllabusRegisterId", syllabusRegisterId + "");
              formData.append("examRoomId", examRoomId + "");
              // console.log("checkAnswer");
              axios
                .post(process.env.VUE_APP_API_URL + "/updateScore", formData, {
                  headers: {
                     token: localStorage.getItem("id_token")
                  },
                })
                .then(async (res) => {
                  Swal.close()
                  let percent = await this.formatNumber(
                    (score.value / listData.value.length) * 100
                  );
                  
                  this.currentScore = listData.value.length;
                  this.currentScoreUser = score.value;
                  this.currentPercent = percent;
                  this.currentTimeSubmit = timeSubmit;
                  this.currentSyllabusId = res.data.data.syllabusId
                  console.log(res.data.syllabusId);
                  
                  if (percent >= this.percentPass) {
                    dialogVisible.value = true;
                    await this.updateProgress();
                  }else{
                    dialogVisible.value = true;
                    await this.updateProgress();
                  }
                  //   Swal.fire({
                  //     title: `<strong>${
                  //       percent >= this.myExam["percentPass"]
                  //         ? "ยินดีด้วย คุณผ่านการทดสอบ!"
                  //         : "เสียใจด้วย คุณไม่ผ่านการทดสอบ"
                  //     }</strong>`,
                  //     html: `${
                  //       percent >= this.myExam["percentPass"]
                  //         ? "กรุณารอการตรวจสอบข้อมูลจากเจ้าหน้าที่ และจะได้รับใบรับรองทันทีหลังข้อมูลได้รับการอนุมัติ"
                  //         : "โปรดติดต่อเจ้าหน้าที่ เพื่อขอทำการทดสอบอีกครั้งโดยจะต้องทำการจองเพื่อขอสอบผ่านระบบเท่านั้น"
                  //     }<br>
                  //  <br>
                  //   <div class="card">
                  //     <div class="card-body">
                  //        <p style="text-align: left;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  //           <path d="M17.6423 2.21644C17.045 2.11355 16.4401 2.06059 15.834 2.05811C13.7659 2.05641 11.741 2.64942 10.0006 3.76644C8.25576 2.66409 6.23118 2.08563 4.16731 2.09978C3.56118 2.10226 2.95631 2.15522 2.35897 2.25811C2.16331 2.29184 1.98612 2.39432 1.85932 2.5471C1.73251 2.69988 1.66442 2.89292 1.66731 3.09144V13.0914C1.66552 13.2139 1.69075 13.3352 1.74118 13.4468C1.79162 13.5584 1.86603 13.6575 1.95912 13.7371C2.05221 13.8166 2.16169 13.8747 2.27977 13.9071C2.39785 13.9396 2.52163 13.9456 2.64231 13.9248C3.83649 13.718 5.05998 13.7523 6.2407 14.0257C7.42142 14.299 8.53549 14.8059 9.51731 15.5164L9.61731 15.5748H9.70897C9.80139 15.6133 9.90052 15.6331 10.0006 15.6331C10.1008 15.6331 10.1999 15.6133 10.2923 15.5748H10.384L10.484 15.5164C11.4589 14.79 12.5698 14.2667 13.7508 13.9776C14.9317 13.6884 16.1587 13.6393 17.359 13.8331C17.4796 13.8539 17.6034 13.8479 17.7215 13.8155C17.8396 13.783 17.9491 13.725 18.0422 13.6454C18.1353 13.5658 18.2097 13.4667 18.2601 13.3551C18.3105 13.2436 18.3358 13.1222 18.334 12.9998V2.99978C18.3253 2.8099 18.252 2.6287 18.1262 2.48622C18.0004 2.34375 17.8296 2.24856 17.6423 2.21644ZM9.16731 13.2914C7.62554 12.4803 5.90941 12.057 4.16731 12.0581C3.89231 12.0581 3.61731 12.0581 3.33397 12.0581V3.72478C3.61152 3.70878 3.88976 3.70878 4.16731 3.72478C5.94513 3.72281 7.68415 4.24452 9.16731 5.22478V13.2914ZM16.6673 12.0914C16.384 12.0914 16.109 12.0914 15.834 12.0914C14.0919 12.0904 12.3757 12.5137 10.834 13.3248V5.22478C12.3171 4.24452 14.0562 3.72281 15.834 3.72478C16.1115 3.70878 16.3898 3.70878 16.6673 3.72478V12.0914ZM17.6423 15.5498C17.045 15.4469 16.4401 15.3939 15.834 15.3914C13.7659 15.3897 11.741 15.9828 10.0006 17.0998C8.26024 15.9828 6.23534 15.3897 4.16731 15.3914C3.56118 15.3939 2.95631 15.4469 2.35897 15.5498C2.2505 15.567 2.14649 15.6055 2.05294 15.663C1.95939 15.7206 1.87814 15.7961 1.81386 15.8851C1.74958 15.9742 1.70354 16.0751 1.67839 16.182C1.65324 16.2889 1.64947 16.3997 1.66731 16.5081C1.70966 16.7245 1.83605 16.9153 2.0188 17.0387C2.20155 17.1621 2.42576 17.208 2.64231 17.1664C3.83649 16.9597 5.05998 16.994 6.2407 17.2673C7.42142 17.5407 8.53549 18.0476 9.51731 18.7581C9.65844 18.8586 9.82739 18.9126 10.0006 18.9126C10.1739 18.9126 10.3428 18.8586 10.484 18.7581C11.4658 18.0476 12.5799 17.5407 13.7606 17.2673C14.9413 16.994 16.1648 16.9597 17.359 17.1664C17.5755 17.208 17.7997 17.1621 17.9825 17.0387C18.1652 16.9153 18.2916 16.7245 18.334 16.5081C18.3518 16.3997 18.348 16.2889 18.3229 16.182C18.2977 16.0751 18.2517 15.9742 18.1874 15.8851C18.1231 15.7961 18.0419 15.7206 17.9483 15.663C17.8548 15.6055 17.7508 15.567 17.6423 15.5498Z" fill="#6B6B6B"/>
                  //         </svg>จำนวนข้อสอบ : ${this.myExam["totalQuestion"]} ข้อ
                  //         </p>
                  //        <p style="text-align: left;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  //           <path d="M16.6654 7.94984C16.6567 7.87328 16.6399 7.79786 16.6154 7.72484V7.64984C16.5753 7.56415 16.5219 7.48539 16.457 7.4165L11.457 2.4165C11.3881 2.35168 11.3094 2.29824 11.2237 2.25817C11.1988 2.25464 11.1736 2.25464 11.1487 2.25817C11.064 2.20962 10.9706 2.17846 10.8737 2.1665H5.83203C5.16899 2.1665 4.53311 2.4299 4.06426 2.89874C3.59542 3.36758 3.33203 4.00346 3.33203 4.6665V16.3332C3.33203 16.9962 3.59542 17.6321 4.06426 18.1009C4.53311 18.5698 5.16899 18.8332 5.83203 18.8332H14.1654C14.8284 18.8332 15.4643 18.5698 15.9331 18.1009C16.402 17.6321 16.6654 16.9962 16.6654 16.3332V7.99984C16.6654 7.99984 16.6654 7.99984 16.6654 7.94984ZM11.6654 5.00817L13.8237 7.1665H12.4987C12.2777 7.1665 12.0657 7.07871 11.9094 6.92243C11.7532 6.76615 11.6654 6.55418 11.6654 6.33317V5.00817ZM14.9987 16.3332C14.9987 16.5542 14.9109 16.7661 14.7546 16.9224C14.5983 17.0787 14.3864 17.1665 14.1654 17.1665H5.83203C5.61102 17.1665 5.39906 17.0787 5.24278 16.9224C5.0865 16.7661 4.9987 16.5542 4.9987 16.3332V4.6665C4.9987 4.44549 5.0865 4.23353 5.24278 4.07725C5.39906 3.92097 5.61102 3.83317 5.83203 3.83317H9.9987V6.33317C9.9987 6.99621 10.2621 7.6321 10.7309 8.10094C11.1998 8.56978 11.8357 8.83317 12.4987 8.83317H14.9987V16.3332ZM11.907 10.7415L9.16536 13.4915L8.09036 12.4082C7.93344 12.2513 7.72062 12.1631 7.4987 12.1631C7.27678 12.1631 7.06395 12.2513 6.90703 12.4082C6.75011 12.5651 6.66195 12.7779 6.66195 12.9998C6.66195 13.2218 6.75011 13.4346 6.90703 13.5915L8.5737 15.2582C8.65117 15.3363 8.74333 15.3983 8.84488 15.4406C8.94643 15.4829 9.05535 15.5047 9.16536 15.5047C9.27537 15.5047 9.3843 15.4829 9.48585 15.4406C9.58739 15.3983 9.67956 15.3363 9.75703 15.2582L13.0904 11.9248C13.2473 11.7679 13.3354 11.5551 13.3354 11.3332C13.3354 11.1113 13.2473 10.8984 13.0904 10.7415C12.9334 10.5846 12.7206 10.4964 12.4987 10.4964C12.2768 10.4964 12.064 10.5846 11.907 10.7415Z" fill="#6B6B6B"/>
                  //         </svg>คะแนนเต็ม : ${this.myExam["totalScore"]} คะแนน
                  //         </p>
                  //        <p style="text-align: left;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  //           <path d="M12.268 7.82484L8.69297 11.4082L7.31797 10.0332C7.24327 9.94594 7.15133 9.87509 7.04795 9.82507C6.94456 9.77505 6.83195 9.74694 6.71718 9.74251C6.60242 9.73807 6.48797 9.75741 6.38104 9.79931C6.2741 9.8412 6.17698 9.90475 6.09576 9.98596C6.01455 10.0672 5.951 10.1643 5.90911 10.2712C5.86721 10.3782 5.84787 10.4926 5.85231 10.6074C5.85674 10.7221 5.88485 10.8348 5.93487 10.9381C5.98489 11.0415 6.05574 11.1335 6.14297 11.2082L8.10131 13.1748C8.17917 13.2521 8.27152 13.3132 8.37305 13.3546C8.47458 13.3961 8.5833 13.4171 8.69297 13.4165C8.91159 13.4156 9.12109 13.3288 9.27631 13.1748L13.443 9.00817C13.5211 8.9307 13.5831 8.83853 13.6254 8.73698C13.6677 8.63544 13.6895 8.52651 13.6895 8.4165C13.6895 8.30649 13.6677 8.19757 13.6254 8.09602C13.5831 7.99447 13.5211 7.90231 13.443 7.82484C13.2868 7.66963 13.0756 7.58251 12.8555 7.58251C12.6353 7.58251 12.4241 7.66963 12.268 7.82484ZM10.0013 2.1665C8.35313 2.1665 6.74196 2.65525 5.37155 3.57092C4.00114 4.4866 2.93304 5.78809 2.30231 7.31081C1.67158 8.83353 1.50655 10.5091 1.8281 12.1256C2.14964 13.7421 2.94331 15.227 4.10875 16.3924C5.27419 17.5578 6.75905 18.3515 8.37555 18.673C9.99206 18.9946 11.6676 18.8296 13.1903 18.1988C14.7131 17.5681 16.0145 16.5 16.9302 15.1296C17.8459 13.7592 18.3346 12.148 18.3346 10.4998C18.3346 9.40549 18.1191 8.32186 17.7003 7.31081C17.2815 6.29976 16.6677 5.3811 15.8939 4.60728C15.12 3.83346 14.2014 3.21963 13.1903 2.80084C12.1793 2.38205 11.0957 2.1665 10.0013 2.1665ZM10.0013 17.1665C8.68276 17.1665 7.39383 16.7755 6.2975 16.043C5.20118 15.3104 4.34669 14.2692 3.84211 13.0511C3.33752 11.8329 3.2055 10.4924 3.46274 9.19924C3.71997 7.90603 4.35491 6.71814 5.28726 5.78579C6.21961 4.85344 7.4075 4.2185 8.7007 3.96127C9.99391 3.70403 11.3344 3.83606 12.5525 4.34064C13.7707 4.84522 14.8119 5.69971 15.5444 6.79604C16.277 7.89236 16.668 9.1813 16.668 10.4998C16.668 12.2679 15.9656 13.9636 14.7154 15.2139C13.4651 16.4641 11.7694 17.1665 10.0013 17.1665Z" fill="#6B6B6B"/>
                  //         </svg>เกณฑ์การผ่าน : ${this.myExam["percentPass"]}
                  //         </p>
                  //        <div class="d-flex">
                  //           <div class="w-50" style="text-align: left;">
                  //            <b>คะแนนของคุณคือ</b>
                  //            <p>${score.value}/${
                  //       this.myExam["totalQuestion"]
                  //     } คะแนน</p>
                  //            <p>เวลาในการทำข้อสอบ : ${timeSubmit} นาที</p>
                  //           </div>
                  //            <div class="progressbar w-50">
                  //             <div class="percent">
                  //               <svg>
                  //                 <circle cx="50" cy="50" r="40"></circle>
                  //                 <circle cx="50" cy="50" r="40" style="--percent: ${percent}"></circle>
                  //               </svg>
                  //               <div class="number">
                  //                 <h3>${percent}<span>%</span></h3>
                  //               </div>
                  //             </div>
                  //           </div>
                  //        </div>
                  //     </div>
                  //   </div>

                  // `,
                  //     showCloseButton: false,
                  //     icon:
                  //       percent >= this.myExam["percentPass"]
                  //         ? "success"
                  //         : "error",
                  //     showCancelButton: false,
                  //     allowOutsideClick: false,
                  //     focusConfirm: false,
                  //     confirmButtonText:
                  //       '<i class="fa fa-thumbs-up"></i> เข้าใจแล้ว',
                  //   }).then(async (result) => {
                  //     if (result.isConfirmed) {
                  //       await this.updateProgress();
                  //     }
                  //   });
                })
                .catch((error) => {
                  // console.log(error);
                  Swal.fire({
                    title: "แจ้งเตือนข้อผิดพลาด",
                    text: error.message,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                    customClass: {
                      confirmButton: "btn fw-semobold btn-light-danger",
                    },
                  });
                });
            })
            .catch((error) => {
              // console.log(error);
              Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: error.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });
        }
      });
    },
    async getCourseRegister(courseId) {
      const courseRegisterId = await axios.get(
        process.env.VUE_APP_API_URL +
          "/getCourseRegister?courseId=" +
          courseId +
          "&userId=" +
          localStorage.getItem("u_id"),
        {
          headers: {
             token: localStorage.getItem("id_token")
          },
        }
      );
      // console.log(courseRegisterId.data.data);
      return courseRegisterId.data.data.content[0].id;
    },
    async updateProgress() {
      const formData = new FormData();
      formData.append(
        "examRoomCode",
        this.examRoomProfile["examRoomCode"] + ""
      );
      // console.log("update");
      await axios
        .post(
          process.env.VUE_APP_API_URL + "/endTestExamRoomRegister",
          formData,
          {
            headers: {
               token: localStorage.getItem("id_token")
            },
          }
        )
        .then((res) => {
          // console.log(res);
         
        })
        .catch((error) => {
          // console.log(error);
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    formatNumber(score) {
      return parseInt(score);
    },
    forceRerender() {
      this.componentKey += 1;
    },
    onBack() {
      submitButton.value= false;
      dialogVisible.value = false;
      localStorage.setItem("reloaded", "1");
      router.push({ name: "mandatory-list" ,params: { id: this.currentSyllabusId }} );
      // router.go(-1);
    },
    convertStoMs(limit, time) {
      const seconds = parseInt(limit) * 60 - parseInt(time) * 60;
      let minutes: any = Math.floor(seconds / 60);
      let extraSeconds: any = seconds % 60;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      extraSeconds = extraSeconds < 10 ? "0" + extraSeconds : extraSeconds;
      return minutes + " : " + extraSeconds;
    },
  },
  beforeUnmount() {
    localStorage.setItem("reloaded", "1");
    clearInterval(this.ticker);
  },
});
</script>
<style>
span.green {
  background: #5ea226;
  border-radius: 0.8em;
  -moz-border-radius: 0.8em;
  -webkit-border-radius: 0.8em;
  color: #ffffff;
  display: inline-block;
  font-weight: bold;
  line-height: 1.6em;
  margin-left: 35px;
  text-align: center;
  width: 1.6em;
}
span.grey {
  background: #cccccc;
  border-radius: 0.8em;
  -moz-border-radius: 0.8em;
  -webkit-border-radius: 0.8em;
  color: #fff;
  display: inline-block;
  font-weight: bold;
  line-height: 1.6em;
  margin-left: 35px;
  text-align: center;
  width: 1.6em;
}
.btn-app {
  background: #da595a;
  color: #ffffff;
  border-radius: 100px;
}
.btn-app2 {
  background: #323563;
  color: #ffffff;
  border-radius: 100px;
}
.btn-exam {
  color: #109448;
  background: #ffffff;
  border: 1px solid #109448 !important;
  width: 160px;
  border-radius: 10px;
}
.btn-exam:hover {
  color: #ffffff;
  background: #109448;
  border-radius: 10px;
}
.btn-exam:disabled {
  background: #e5e5e5;
  color: #979797;
  border: 1px solid #d8d8d8 !important;
  border-radius: 10px;
}
.btn-register {
  background: #f2a17d;
  color: #ffffff;
  width: 70%;
  border-radius: 21px;
}
</style>
